// Gallery JS
import 'lazysizes';

const galleryCarouselEl = document.querySelector('.gallery-carousel');

if (galleryCarouselEl) {
  const mobileBp = '992px';
  let flkty;

  function initCarousel() {
    flkty = new Flickity( '.gallery-carousel', {
      wrapAround: true,
      cellAlign: 'left',
      pageDots: false,
      adaptiveHeight: false,
      setGallerySize: false,
      arrowShape: 'M 100,47.3 10.7,47.3 26.9,31.4 23.1,27.5 0,50 23.1,72.5 26.9,68.6 10.7,52.8 100,52.8 Z'
    });
  }

  // Create a condition that targets viewports at least 768px wide
  const mediaQuery = window.matchMedia(`(min-width: ${mobileBp})`);

  function handleMobileChange(e) {
    if (e.matches) {
      initCarousel();
    } else {
      if (flkty) {
        flkty.destroy();
      }
    }
  }

  // Register event listener
  mediaQuery.addEventListener('change', handleMobileChange);

  // Initial check
  handleMobileChange(mediaQuery);
}
